import { render } from "./CaseCategory.vue?vue&type=template&id=2edba2c5&scoped=true"
import script from "./CaseCategory.vue?vue&type=script&lang=js"
export * from "./CaseCategory.vue?vue&type=script&lang=js"

import "./CaseCategory.vue?vue&type=style&index=0&id=2edba2c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edba2c5"]])

export default __exports__